<div class="vz-backdrop" animate.enter="vza-show-op" (click)="close()" #backdropEl></div>
<div class="vz-drawer vz-drawer-right" style="transition: width .2s ease-out;"
    [style.width]="_mobile() ? '100%' : '550px'"
    animate.enter="vza-show-rx"
    #drawerEl>
    <div class="vz-drawer-header layout center">
        <div class="layout flex center gap05">
            <i class="vz-btn-c vzi-cross fs-3xl mr05" (click)="close()"></i>
            <span>{{ single() ? 'Выберите чат' : 'Выберите чаты' }}</span>
            <span class="flex"></span>
            @if (!single()) {
                <button nz-button nzType="primary" (click)="close(controller.getSelectedItems())">{{ okText() }}</button>
            }
        </div>
    </div>
    <div class="vz-drawer-body">
        <div class="chats-select-root layout fit vertical" [class.chats-select-single]="single()">
            <div class="layout p05 gap025">
                <vz-ctrl-search [controller]="controller" [filterController]="filterController" [showFilter]="!noFilters" placeholder="Фильтр..." />
            </div>
            <div class="layout flex relative">
                @if (_error(); as err) {
                    <div class="fit layout center-center">
                        <vz-error-panel [error]="err" />
                    </div>
                }
                @else {
                    <dm-table class="fit ngx-dmt-clickable"
                        [controller]="controller"
                        moveableColumns="false"
                        showSelectColumn="true"
                        itemSize="56">
                        <ng-template #noItemsVisible>
                            <div class="layout vertical fit center-center bg tac p1">
                                <span class="no-text fs-xl">Под данный фильтр не подходит ни один чат</span>
                            </div>
                        </ng-template>
                        <ng-template #selectColumnHeader let-all="all" let-none="none">
                            <div class="layout center" style="text-align: left; padding-left: 20px;">
                                <label nz-checkbox [ngModel]="all" [nzIndeterminate]="!all && !none"></label>
                                @let cs = cState();
                                @if (cs && cs.itemsSelected > 0) {
                                    <span class="ml1 fw-n txt-p">выбрано {{ cs.itemsSelected }} из {{ cs.itemsTotal }}</span>
                                }
                            </div>
                        </ng-template>
                        <ng-template #selectColumn let-checked let-row="row">
                            <vz-chat-row class="layout flex pe-all ph05"
                                [chatId]="row.id"
                                [avatarSize]="42"
                                [checked]="checked"
                                [selectable]="!single"
                                (checkedChange)="controller.toggleSelected(row.id)"
                                (itemClick)="single() ? close([row]) : controller.toggleSelected(row.id)" />
                        </ng-template>
                        <ng-template #groupHeader let-gr="group">
                            <b>{{ gr.data?.title }}</b>
                        </ng-template>
                    </dm-table>
                }
                @if (_loading()) {
                    <vz-loading />
                }
            </div>
        </div>
    </div>
</div>
